import { timelineAvailable } from '@config/navigationRestrictions';
import { navigationLevels } from '@v2/pages/machines/common/constants';
import { LevelSubScreen, LevelSubScreenLink } from '@v2/pages/common/enums';

interface NestedScreenConfig {
  screenName: string;
  items: Record<string, string>;
  links: Record<string, string>;
}

interface Config {
  levels: Record<string, string>;
  links: Record<string, string>;
  nestedScreens?: Record<string, NestedScreenConfig>;
}

export const createLevelSubScreenLinking = (
  screenName: string,
  { levels, links, nestedScreens }: Config = { levels: LevelSubScreen, links: LevelSubScreenLink }
) => {
  return Object.entries(levels).reduce((acc, [key, value]) => {
    const newKey = screenName + value;

    // Check if this screen has a nested configuration
    const nestedConfig = nestedScreens?.[value];

    if (nestedConfig) {
      const nestedLinking = Object.entries(nestedConfig.items).reduce((nestedAcc, [itemKey, itemValue]) => {
        const nestedKey = newKey + itemValue;
        nestedAcc[nestedKey] = nestedConfig.links[itemKey];
        return nestedAcc;
      }, {} as Record<string, string>);

      acc[newKey] = {
        path: links[key],
        screens: nestedLinking,
      };
    } else if (value === LevelSubScreen.PERFORMANCE) {
      // Keep backward compatibility for Performance
      const metricTypeLinking = Object.entries(navigationLevels.metricTypes).reduce((perfAcc, [perfKey, perfValue]) => {
        const newPerformanceKey = newKey + perfValue;
        perfAcc[newPerformanceKey] = perfKey;
        return perfAcc;
      }, {} as Record<string, string>);

      acc[newKey] = {
        path: links[key],
        screens: metricTypeLinking,
      };
    } else {
      acc[newKey] = links[key];
    }

    return acc;
  }, {} as Record<string, string | { path: string; screens: Record<string, string> }>);
};

export const filterTimelineFromEnum = <T extends Record<string, string>>(enumObj: T, timelineValue: string): Partial<T> => {
  if (timelineAvailable) return enumObj;

  return Object.keys(enumObj).reduce((acc, key) => {
    if (enumObj[key] !== timelineValue) {
      acc[key] = enumObj[key];
    }
    return acc;
  }, {} as Partial<T>);
};
